import {css} from "@panda/css";

import {InputField, PhoneFieldControlled} from "@pg-design/rhf-components-module";
import {MULTILEAD_RESPONSIVE_MODAL_TEST_IDS} from "@pg-mono/test-ids";

import {useAppSelector} from "../../../store/hooks";
import {IEmailVerificationProps} from "../../../user/hooks/use_email_verification";
import {leadModalZindex} from "../../constants/lead/lead_modal_zindex";
import {ApplicationEmailVerificationPopover} from "../ApplicationEmailVerificationPopover";

interface IProps {
    emailNotificationProps: IEmailVerificationProps;
}

export const ApplicationMultiLeadResponsiveModalUserDataFields = (props: IProps) => {
    const {emailNotificationProps} = props;
    const countryCodes = useAppSelector((state) => state.variables.data?.country_codes ?? []);

    return (
        <div className={fieldsStyle}>
            <InputField name="name" placeholder="Imię i nazwisko" dataTestId={MULTILEAD_RESPONSIVE_MODAL_TEST_IDS.NAME_INPUT} />
            <ApplicationEmailVerificationPopover {...emailNotificationProps} popoverPlace="bottom" zIndex={leadModalZindex}>
                <InputField name="email" placeholder="Email" dataTestId={MULTILEAD_RESPONSIVE_MODAL_TEST_IDS.EMAIL_INPUT} />
            </ApplicationEmailVerificationPopover>
            <PhoneFieldControlled
                name="phone"
                codes={countryCodes}
                placeholder="Telefon"
                className="bt"
                dataTestId={MULTILEAD_RESPONSIVE_MODAL_TEST_IDS.PHONE_INPUT}
            />
        </div>
    );
};

const fieldsStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 1
});
import {css} from "@panda/css";

import {InputField, PhoneFieldControlled} from "@pg-design/rhf-components-module";
import {MULTILEAD_RESPONSIVE_MODAL_TEST_IDS} from "@pg-mono/test-ids";

import {useAppSelector} from "../../../store/hooks";
import {IEmailVerificationProps} from "../../../user/hooks/use_email_verification";
import {leadModalZindex} from "../../constants/lead/lead_modal_zindex";
import {ApplicationEmailVerificationPopover} from "../ApplicationEmailVerificationPopover";

interface IProps {
    emailNotificationProps: IEmailVerificationProps;
}

export const ApplicationMultiLeadResponsiveModalUserDataFields = (props: IProps) => {
    const {emailNotificationProps} = props;
    const countryCodes = useAppSelector((state) => state.variables.data?.country_codes ?? []);

    return (
        <div className={fieldsStyle}>
            <InputField name="name" placeholder="Imię i nazwisko" dataTestId={MULTILEAD_RESPONSIVE_MODAL_TEST_IDS.NAME_INPUT} />
            <ApplicationEmailVerificationPopover {...emailNotificationProps} popoverPlace="bottom" zIndex={leadModalZindex}>
                <InputField name="email" placeholder="Email" dataTestId={MULTILEAD_RESPONSIVE_MODAL_TEST_IDS.EMAIL_INPUT} />
            </ApplicationEmailVerificationPopover>
            <PhoneFieldControlled
                name="phone"
                codes={countryCodes}
                placeholder="Telefon"
                className="bt"
                dataTestId={MULTILEAD_RESPONSIVE_MODAL_TEST_IDS.PHONE_INPUT}
            />
        </div>
    );
};

const fieldsStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 1
});
